import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-45ba463b")
const _hoisted_1 = {
  cass: "stats",
  id: "stats"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "data-list__title" }, "Base Stats", -1)
const _hoisted_3 = { class: "stats__card-container" }
const _hoisted_4 = { class: "stats__card-name" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (statData) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "stats__card",
          key: statData.stat.name
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(statData.stat.name.replace("special", "spc.").replace("-", " ")), 1),
          _createElementVNode("div", {
            class: _normalizeClass([
            'stats__card-value',
            `stats__card-value--${statData.stat.name}`,
          ])
          }, _toDisplayString(statData.base_stat), 3)
        ]))
      }), 128))
    ])
  ]))
}